import m from "../../../../geodata/es2015/region/usa/sdHigh";
window.am4geodata_region_usa_sdHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/sdHigh.js
// module id = null
// module chunks = 